export const userSettings = {
	dashboardFilters: {
		myLocationSketches: true,
		createSketch: true,
		searchLogo: true,
		mySketches: true,
		myDrafts: true,
	},
};
